import { useTheme, useMediaQuery } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { myTheme } from '../hooks/useThemeMode';

interface ActiveLinkProps {
  icon?: React.ReactNode;
  to: string;
  children: React.ReactNode;
  isVisible: boolean;
}

const ActiveLink = ({ icon, to, children, isVisible }: ActiveLinkProps) => {
  const location = useLocation();
  const theme = useTheme();
  const isActive = location.pathname === to;
  const isMobile = useMediaQuery(theme.breakpoints.down(900));

  const isFullScreen = myTheme === 'Theme2';
  return (
    <Link
      to={to}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isMobile ? '14px' : '10px',
        fontSize: isMobile ? '14px' : '16px',
        // padding: isMobile ? '5px 16px' : '6px 16px',
        // borderRadius: '4px',
        margin: isMobile ? '0' : '0 20px 0 0',
        textDecoration: 'none',
        textAlign: 'left',
        textTransform: 'uppercase',
        transition: 'all 0.3s ease-in-out',
        color: isActive
          ? theme.palette.primary.main
          : isFullScreen
            ? isVisible
              ? theme.palette.text.primary
              : theme.palette.text.secondary
            : theme.palette.text.primary,
        // backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
        borderBottom: isActive
          ? `4px solid ${theme.palette.primary.main}`
          : 'none',

        width: isMobile ? '100%' : 'auto',
      }}
      className='active-link'
    >
      {icon && (
        <span
          style={{
            display: 'inline-block',
            width: isMobile ? '22px' : '25px',
            textAlign: 'center',
          }}
        >
          {icon}
        </span>
      )}
      {children}
    </Link>
  );
};

export default ActiveLink;
